module.exports = __webpack_public_path__ + "img/use-scenes.50cbf94.svg";